// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AutoTabController from "./auto_tab_controller"
application.register("auto-tab", AutoTabController)

import BasketController from "./basket_controller"
application.register("basket", BasketController)

import BootstrapCarouselController from "./bootstrap_carousel_controller"
application.register("bootstrap-carousel", BootstrapCarouselController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import DatatransController from "./datatrans_controller"
application.register("datatrans", DatatransController)

import DynamicAnchorController from "./dynamic_anchor_controller"
application.register("dynamic-anchor", DynamicAnchorController)

import FarmsMapController from "./farms_map_controller"
application.register("farms-map", FarmsMapController)

import FramePopoverController from "./frame_popover_controller"
application.register("frame-popover", FramePopoverController)

import FundraisingMapController from "./fundraising_map_controller"
application.register("fundraising-map", FundraisingMapController)

import MainController from "./main_controller"
application.register("main", MainController)

import MobileNavbarController from "./mobile_navbar_controller"
application.register("mobile-navbar", MobileNavbarController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PausesController from "./pauses_controller"
application.register("pauses", PausesController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ProductsFilterController from "./products_filter_controller"
application.register("products-filter", ProductsFilterController)

import ScannerController from "./scanner_controller"
application.register("scanner", ScannerController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
